import actions from "./actions";

const {
    FETCH_HOLIDAY_DECLARATIONS,
    FETCH_HOLIDAY_DECLARATION,
    RESET_HOLIDAY_DECLARATION
} = actions;

const initState = {
    holidayDeclarations: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    holidayDeclaration: { _id: null }
};

const HolidayDeclarationReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_HOLIDAY_DECLARATIONS:
            return {
                ...state,
                holidayDeclarations: data
            };
        case RESET_HOLIDAY_DECLARATION:
            return {
                ...state,
                holidayDeclaration: initState.holidayDeclaration
            };
        case FETCH_HOLIDAY_DECLARATION:
            return {
                ...state,
                holidayDeclaration: data
            };
        default:
            return state;
    }
};

export default HolidayDeclarationReducer;